export const NPS_QUESTION_KIND_OPTIONS = [
  { label: 'NPS', value: 'NPS' },
  { label: 'Multipla escolha', value: 'MULTIPLE_SELECTION_BOX' },
  { label: 'Texto', value: 'SHORT_TEXT' },
  { label: 'Número', value: 'INTEGER' },
]
